// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1788760844932
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  